// extracted by mini-css-extract-plugin
export default {"container":"ErrorAlert_container__DyqgW","alert":"ErrorAlert_alert__fxj6k"};